<template>
    <auth-layout :image="1" :byword="$t('pages.auth.signup.steps.register.byword')" :isProgressBarHidden="true">
        <common-content-wrapper width="small">
            <common-page-header :heading="$t('pages.auth.signup.demo.register.heading')"></common-page-header>
        </common-content-wrapper>
        <common-content-wrapper width="small">
            <auth-signup-demo-form></auth-signup-demo-form>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import AuthLayout from 'components/layouts/AuthLayout'
    import AuthSignupDemoForm from 'components/forms/AuthSignupDemoForm'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'

    export default {
        metaInfo() {
            if (process.env.VUE_APP_ENV === 'production') {
                return {
                    title: this.$t('pages.auth.signup.demo.register.title'),
                    meta: [
                        { name: 'description', content: this.$t('pages.auth.signup.demo.register.page_description') },
                        { name: 'keywords', content: this.$t('pages.auth.signup.demo.register.page_keywords') },
                        { name: 'author', content: this.$t('pages.auth.signup.demo.register.page_author') },
                        { name: 'robots', content: this.$t('pages.auth.signup.demo.register.page_robots') },
                    ],
                }
            }
        },

        mixins: [PageWithTitleMixin],
        components: {
            AuthLayout,
            AuthSignupDemoForm,
        },

        computed: {
            pageTitle() {
                return this.$t('pages.auth.signup.demo.register.title')
            },

            pageDescription() {
                return this.$t('pages.auth.signup.demo.register.description')
            },

            pageImage() {
                return 'https://medmatchnetwork.com/wp-content/uploads/2024/07/medmatch-network-og-image.png'
            },
        },
    }
</script>
